/* eslint-disable prettier/prettier */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-seleccion-potencia-modal',
  templateUrl: './seleccion-potencia-modal.component.html',
  styleUrls: ['./seleccion-potencia-modal.component.scss'],
})
export class SeleccionPotenciaModalComponent {
  public potencias: number[] = [0, 20, 40, 60, 80, 100];
  public selectedPotencia: number | null = null;

  constructor(
    public dialogRef: MatDialogRef<SeleccionPotenciaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.selectedPotencia = data?.actual || 100;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  seleccionarPotencia(potencia: number): void {
    this.selectedPotencia = potencia;
  }

  confirmarPotencia(): void {
    if (this.selectedPotencia !== null) {
      this.dialogRef.close(this.selectedPotencia);
    }
  }
}
